import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { MetricWidgetBase } from '@components/overview-dashboard/common/mixins';

export const DimensionWidget = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DimensionWidgetWrapper = styled.div`
  ${MetricWidgetBase};
  height: fit-content;
  padding: 5px 0 !important;

  ${breakpoint('tablet')`
        width: 100%;
    `};

  ${breakpoint('desktop')`
        width: 100%;
    `};

  ${breakpoint('mobile')`
        width: 100%;
    `};
`;

export const DimensionTableContainer = styled.div`
  ${MetricWidgetBase};
  margin-top: 5px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-evenly;
  height: fit-content;

  ${breakpoint('tablet')`
      width: 100%;
  `};

  ${breakpoint('desktop')`
      width: 100%;
  `};

  ${breakpoint('mobile')`
      width: 100%;
  `};
`;

export const HeaderFlexWrap = styled.div`
  display: flex;
  padding: 5px 0;
`;
export const TitleFlexWrap = styled.div`
  flex-grow: 1;
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;
  padding: 0 0 0 12px;

  ${breakpoint('mobile')`
      width: 80%;
  `};
`;

export const DisabledUnitToggle = styled.div`
  pointer-events: none;
  color: #f6f6f6;
  opacity: 0.4;
  cursor: not-allowed;
  margin-right: 10px;
`;

export const UnitToggleWrapper = styled.div`
  margin-right: 10px;
`;

export const ViewToggleWrapper = styled.div`
  margin-left: 10px;
`;
